import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import DmsViewer from './dms-viewer';
import { register as blueRegister } from '@onviobr/element';
import { AnnotationLocation, AnnotationDropDataTransferKey, AnnotationDescription, EventType } from './dms-viewer-interface';
import { AnnotationAppearance } from './models/annotation-appearance';
import { getPageNumber, viewportToPage, rectFitsIntoPage, initializeDroppedAnnotation, getPlaceholderCoordinatesFromAnnotation, getAnnotationCoordinatesFromPlaceholder } from './coordinate-conversion';
export var DmsViewerWithAnnotations = /*#__PURE__*/function (_DmsViewer) {
  function DmsViewerWithAnnotations() {
    var _this;
    _classCallCheck(this, DmsViewerWithAnnotations);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DmsViewerWithAnnotations, [].concat(args));
    _this.annotations = void 0;
    _this.respectRotationInPlaceholders = false;
    return _this;
  }
  _inherits(DmsViewerWithAnnotations, _DmsViewer);
  return _createClass(DmsViewerWithAnnotations, [{
    key: "annotationMetadataKey",
    get: function get() {
      return 'annotation-metadata';
    }
  }, {
    key: "updated",
    value: function updated(changes) {
      _superPropGet(DmsViewerWithAnnotations, "updated", this, 3)([changes]);
      if (changes.has('annotations')) {
        this.putAnnotations();
      }
    }
  }, {
    key: "initializeWebViewerInstance",
    value: function () {
      var _initializeWebViewerInstance = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var features;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              void _superPropGet(DmsViewerWithAnnotations, "initializeWebViewerInstance", this, 3)([]);
              this.initializeDragDrop();
              this.webViewer.UI.annotationPopup.update([{
                dataElement: 'annotationDeleteButton'
              }]);
              features = this.webViewer.UI.Feature;
              this.webViewer.UI.disableFeatures([features.TextSelection, features.Redaction, features.Annotations]);
              return _context.abrupt("return", Promise.resolve());
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initializeWebViewerInstance() {
        return _initializeWebViewerInstance.apply(this, arguments);
      }
      return initializeWebViewerInstance;
    }()
  }, {
    key: "setLoadingState",
    value: function setLoadingState(value) {
      _superPropGet(DmsViewerWithAnnotations, "setLoadingState", this, 3)([value]);
      if (!value) {
        this.zoomUpdated();
      }
    }
  }, {
    key: "initializeDragDrop",
    value: function initializeDragDrop() {
      var webViewer = this.webViewer;
      var body = webViewer.UI.iframeWindow.document.body;
      var docViewer = webViewer.Core.documentViewer;
      var annotationManager = docViewer.getAnnotationManager();
      body.ondragover = this.onDragOver.bind(this);
      body.ondrop = this.onDrop.bind(this);
      annotationManager.addEventListener('annotationChanged', this.annotationChanged.bind(this));
      docViewer.addEventListener('zoomUpdated', this.zoomUpdated.bind(this));
    }
  }, {
    key: "zoomUpdated",
    value: function zoomUpdated() {
      if (this.webViewer) {
        var docViewer = this.webViewer.Core.documentViewer;
        this.emit(EventType.ZoomChange, docViewer.getZoomLevel());
      }
    }
  }, {
    key: "onDrop",
    value: function onDrop(e) {
      if (!this.webViewer || this.options.readonly) {
        return false;
      }
      if (e.dataTransfer) {
        var dropDataString = e.dataTransfer.getData(AnnotationDropDataTransferKey);
        var dropData = dropDataString && JSON.parse(dropDataString);
        if (dropData) {
          var webViewer = this.webViewer;
          var point = {
            x: e.pageX,
            y: e.pageY
          };
          var image = dropData.img;
          var size = dropData.size;
          var offset = dropData.offset;
          var metadata = dropData.metadata;
          var appearance = new AnnotationAppearance(new AnnotationLocation(point, undefined), size, offset, 'viewport');
          this.addStampAnnotation(webViewer, image, appearance, metadata);
        }
      }
      e.preventDefault();
      return false;
    }
  }, {
    key: "onDragOver",
    value: function onDragOver(e) {
      e.preventDefault();
      return false;
    }
  }, {
    key: "putAnnotations",
    value: function putAnnotations() {
      if (this.annotations) {
        this.annotations.forEach(this.addExistingAnnotation.bind(this));
      }
    }
  }, {
    key: "addExistingAnnotation",
    value: function addExistingAnnotation(placeholder) {
      var coordinates;
      if (this.respectRotationInPlaceholders) {
        coordinates = {
          x: placeholder.location.coordinates.x,
          y: placeholder.location.coordinates.y
        };
      } else {
        var pageNumber = placeholder.location.pageNumber;
        var rotation = this.webViewer.Core.documentViewer.getCompleteRotation(pageNumber) * 90;
        var pageSize = {
          width: this.webViewer.Core.documentViewer.getPageWidth(pageNumber),
          height: this.webViewer.Core.documentViewer.getPageHeight(pageNumber)
        };
        coordinates = getAnnotationCoordinatesFromPlaceholder(placeholder.location.coordinates, rotation, pageSize);
      }
      var appearance = new AnnotationAppearance(new AnnotationLocation(coordinates, placeholder.location.pageNumber), placeholder.size, {
        x: 0,
        y: 0
      }, 'page');
      this.addStampAnnotation(this.webViewer, placeholder.img, appearance, placeholder.metadata);
    }
  }, {
    key: "addStampAnnotation",
    value: function addStampAnnotation(webViewer, imgData, appearance, annotationMetadata) {
      var Annotations = webViewer.Core.Annotations;
      var docViewer = webViewer.Core.documentViewer;
      var point = appearance.location.coordinates;
      var pageNumber;
      if (appearance.location.pageNumber) {
        pageNumber = appearance.location.pageNumber;
      } else {
        pageNumber = getPageNumber(docViewer, point);
      }
      var pagePoint = appearance.coordinateSystem === 'page' ? point : viewportToPage(docViewer, point, pageNumber);
      var fitsIntoPage = rectFitsIntoPage(docViewer, pageNumber, pagePoint, appearance);
      if (!fitsIntoPage) {
        return;
      }
      var stampAnnotation = new Annotations.StampAnnotation();
      stampAnnotation.PageNumber = pageNumber;
      var rotation = docViewer.getCompleteRotation(pageNumber) * 90;
      stampAnnotation.Rotation = rotation;
      stampAnnotation.NoResize = true;
      initializeDroppedAnnotation(stampAnnotation, pagePoint, appearance, rotation);
      void stampAnnotation.setImageData(imgData);
      var annotationManager = docViewer.getAnnotationManager();
      stampAnnotation.Author = annotationManager.getCurrentUser();
      if (annotationMetadata) {
        stampAnnotation.setCustomData(this.annotationMetadataKey, annotationMetadata);
      }
      annotationManager.deselectAllAnnotations();
      annotationManager.addAnnotation(stampAnnotation, {
        imported: false
      });
      annotationManager.redrawAnnotation(stampAnnotation);
    }
  }, {
    key: "annotationChanged",
    value: function annotationChanged(annotations, action) {
      var _this2 = this;
      if (!this.documentIsLoading) {
        var changedAnnotations = [];
        var annotationMap = new Map();
        annotations.forEach(function (annotation) {
          var metadata = annotation.getCustomData(_this2.annotationMetadataKey);
          if (metadata) {
            var coordinates;
            if (_this2.respectRotationInPlaceholders) {
              coordinates = {
                x: annotation.getX(),
                y: annotation.getY()
              };
            } else {
              var rotation = _this2.webViewer.Core.documentViewer.getCompleteRotation(annotation.PageNumber) * 90;
              var pageSize = {
                width: _this2.webViewer.Core.documentViewer.getPageWidth(annotation.PageNumber),
                height: _this2.webViewer.Core.documentViewer.getPageHeight(annotation.PageNumber)
              };
              coordinates = getPlaceholderCoordinatesFromAnnotation(annotation, rotation, pageSize);
            }
            var annotationDescription = new AnnotationDescription(new AnnotationLocation(coordinates, annotation.PageNumber), metadata);
            changedAnnotations.push(annotationDescription);
            annotationMap.set(annotationDescription, annotation);
          }
        });
        if (changedAnnotations.length) {
          this.emit(EventType.AnnotationsChange, {
            action: action,
            annotations: changedAnnotations
          });
          changedAnnotations.forEach(function (annotationDescription) {
            var updatedMetadata = annotationDescription.metadata;
            var annotation = annotationMap.get(annotationDescription);
            annotation.setCustomData(_this2.annotationMetadataKey, updatedMetadata);
          });
        }
      }
    }
  }], [{
    key: "is",
    get: function get() {
      return 'dms-viewer-with-annotations';
    }
  }, {
    key: "properties",
    get: function get() {
      return _objectSpread(_objectSpread({}, _superPropGet(DmsViewerWithAnnotations, "properties", this)), {}, {
        annotations: {
          type: Object,
          reflect: false
        },
        respectRotationInPlaceholders: {
          type: Boolean,
          reflect: false
        }
      });
    }
  }]);
}(DmsViewer);
export var registerViewerWithAnnotations = function registerViewerWithAnnotations() {
  return blueRegister(DmsViewerWithAnnotations);
};
